import React, { Fragment } from 'react';
import { useConfirmCrewDeliveryMutation } from '../../../redux/api/crewDeliveryApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useApiErrorToast } from '../../../hooks/useApiError';

// A line is ready to confirm only once it carries an explicit, non-negative
// integer quantity. Empty/null fields keep the confirm button blocked so we
// never send a partial/NULL confirmation to the backend.
const isFilled = (line) =>
  Number.isInteger(line.actual_quantity) && line.actual_quantity >= 0;

const ConfirmCrewDelivery = ({
  deliveryLines,
  deliveryId,
  isReturn = false,
}) => {
  const [confirmDelivery, { isLoading }] = useConfirmCrewDeliveryMutation();
  const navigate = useNavigate();
  const apiErrorToast = useApiErrorToast();

  const docLabel = isReturn ? 'Retoure' : 'Lieferung';
  const openCount = deliveryLines.filter((line) => !isFilled(line)).length;

  const handleSubmit = async () => {
    const submitObj = {
      id: deliveryId,
      items: deliveryLines.map((deliveryLine) => ({
        item_id: deliveryLine.id,
        actual_quantity: deliveryLine.actual_quantity,
      })),
    };

    try {
      await confirmDelivery(submitObj).unwrap();
      toast.success(`${docLabel} wurde erfolgreich bestätigt!`);
      navigate('/');
    } catch (err) {
      apiErrorToast(err, 'Fehler beim Bestätigen!');
    }
  };

  return deliveryLines && deliveryId ? (
    <Fragment>
      <button
        className='btn btn-success ms-2'
        onClick={handleSubmit}
        disabled={!deliveryLines || isLoading || openCount > 0}
      >
        {docLabel} bestätigen
      </button>
      {openCount > 0 && (
        <p className='text-danger mt-2 mb-0'>
          <i className='fas fa-exclamation-triangle me-1' />
          Bitte alle Mengen eintragen ({openCount} offen)
        </p>
      )}
    </Fragment>
  ) : null;
};

export default ConfirmCrewDelivery;
